import React from "react";

import Typography from "@mui/material/Typography";

import "../App.css"
import {useAppCtx} from "./AppCtx"
import {Archive} from "../cmp/Archive"
import {ArchiveDetail, ArchiveDetailFromTask} from "../cmp/ArchiveDetail";
import {CodeList} from "../cmp/CodeList"
import {CodeCreate, CodeUpdate, CodeSort} from "../cmp/CodeEditor";
import {CrewList} from "../cmp/CrewList"
import {CrewCreate, CrewUpdate, CrewShow} from "../cmp/CrewEditor";
import {TeamList} from "../cmp/TeamList";
import {Home} from "../cmp/Home";
import {OperStatus, OperContext, OperCache, OperDDL, OperTypo} from "../cmp/Oper";
import {ProjectList} from "../cmp/ProjectList"
import {ProjectCreate, ProjectUpdate } from "../cmp/ProjectEditor"
import {ProjectDetail, ProjectDetailFromTask} from "../cmp/ProjectDetail";
import {ProjectSearch} from "../cmp/ProjectSearch";
import {TaskList} from "../cmp/TaskList";
import {TeamCreate, TeamUpdate, TeamShow} from "../cmp/TeamEditor";
import {TaskCreate, TaskClone, TaskUpdate, TaskShow} from "../cmp/TaskEditor";
import {TaskSearch, TaskWarrantySearch} from "../cmp/TaskSearch";
import {SiteSearch} from "../cmp/SiteSearch";
import {Login, PwChange} from "../cmp/Auth";
import {ProjectListAvor} from "../cmp/ProjectListAvor";

export function AppPage() {
    const { currentMenu, isLoggedIn } = useAppCtx();

    const renderPage =() => {

        const pageMap = {
            login                   : () => <Login />,
            pwChange                : () => <PwChange />,

            home                    : () => <Home />,

            project                 : () => <ProjectList />,
            projectAvor             : () => <ProjectListAvor />,
            projectCreate           : () => <ProjectCreate />,
            projectUpdate           : () => <ProjectUpdate />,
            projectDetail           : () => <ProjectDetail />,
            projectDetailFromTask   : () => <ProjectDetailFromTask />,
            projectSearch           : () => <ProjectSearch />,

            task                    : () => <TaskList />,
            taskCreate              : () => <TaskCreate />,
            taskClone               : () => <TaskClone />,
            taskUpdate              : () => <TaskUpdate />,
            taskShow                : () => <TaskShow />,
            taskSearch              : () => <TaskSearch />,
            taskWarrantySearch      : () => <TaskWarrantySearch />,

            siteSearch              : () => <SiteSearch />,

            crew                    : () => <CrewList   type="crew" />,
            crewCreate              : () => <CrewCreate type="crew" />,
            crewUpdate              : () => <CrewUpdate type="crew" />,
            crewShow                : () => <CrewShow   type="crew" />,

            contractor              : () => <CrewList   type="contractor" />,
            contractorCreate        : () => <CrewCreate type="contractor" />,
            contractorUpdate        : () => <CrewUpdate type="contractor" />,
            contractorShow          : () => <CrewShow   type="contractor" />,

            team                    : () => <TeamList />,
            teamCreate              : () => <TeamCreate />,
            teamUpdate              : () => <TeamUpdate />,
            teamShow                : () => <TeamShow />,

            codeCategory            : () => <CodeList type="Category" />,
            codeTask                : () => <CodeList type="Task" />,
            codeTool                : () => <CodeList type="Tool" />,
            codeCreate              : () => <CodeCreate />,
            codeUpdate              : () => <CodeUpdate />,
            codeSort                : () => <CodeSort />,

            archive                 : () => <Archive />,
            archiveDetail           : () => <ArchiveDetail />,
            archiveDetailFromTask   : () => <ArchiveDetailFromTask />,

            operStatus              : () => <OperStatus />,
            operContext             : () => <OperContext />,
            operCache               : () => <OperCache />,
            operDDL                 : () => <OperDDL />,
            operTypo                : () => <OperTypo />
        };

        // redirect to login-page if user is not logged-in or change-pw
        if (!isLoggedIn && !(currentMenu === 'pwChange')) {
            return pageMap['login']()
        }

        // return page or fallback (if no entry is found)
        const renderFn = pageMap[currentMenu];
        return renderFn ? renderFn() : <Typography variant="h4">{currentMenu}</Typography>;
    }

    return (
        <div id="apppage" className="AppPage">
            { renderPage() }
        </div>
    );
}
